import React from "react";
import { Route, Switch } from "react-router-dom";
import MPP from "./container/mppmodal/MppInfo";
import {
  GlobalErrorPage,
  TransactionPage,
  MerchantPriceErrorPage,
} from "./container/globalError/GlobalErrorPage";

function App() {
  
  return (
    <Switch>
      <Route path="/mpp/successPage" component={TransactionPage} />
      <Route path="/mpp/GlobalErrorPage" component={GlobalErrorPage} />
      <Route path="/mpp/MerchantPriceErrorPage" component={MerchantPriceErrorPage} />
      <Route path="/mpp" component={MPP} />
    </Switch>
  );
}

export default App;
